
import Vue from "vue";
import { PropType } from "vue";
import { welcomeToTheMoonMixins } from "@/mixins/welcomeToTheMoonMixins";
import { WelcomeToTheMoonAdventure, WelcomeToTheMoonPlay } from "@/types";

export default Vue.extend({
  name: "WelcomeToTheMoonScoresByAdventure",
  mixins: [welcomeToTheMoonMixins],
  props: {
    adventures: {
      type: Array as PropType<WelcomeToTheMoonAdventure[]>,
      required: true,
      default: [],
    },
    plays: {
      type: Array as PropType<WelcomeToTheMoonPlay[]>,
      required: true,
      default: [],
    },
    mainPlayerId: {
      type: Number,
      default: 1,
    },
  },
});
